import React, { createContext, useContext } from "react";
import useConfirm from "./useConfirm";

const ConfirmDialogContext = createContext(null);

export function ConfirmDialogProvider({ children }) {
  const [ConfirmDialog, confirmDialog] = useConfirm();
  return (
    <ConfirmDialogContext.Provider value={confirmDialog}>
      <ConfirmDialog />
      {children}
    </ConfirmDialogContext.Provider>
  );
}

export function useConfirmDialog() {
  return useContext(ConfirmDialogContext);
}
